import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RbacService } from '../services/rbac.service';

/** Gates Settings using the Sync Access RBAC rule: role === 'ADMIN' OR featureAccessType === 'ADMIN'. */
export const adminFeatureAccessGuard: CanActivateFn = () => {
  const rbacService = inject(RbacService);
  const router = inject(Router);

  return rbacService.hasAdminFeatureAccess() ? true : router.createUrlTree(['/dashboard']);
};
